/* global axios */
import ApiClient from '../ApiClient';

class TravelRequestEvents extends ApiClient {
  constructor() {
    super('travel/request_events', { accountScoped: true });
  }

  get({ page = 1 } = {}) {
    return axios.get(this.url, { params: { page } });
  }
}

export default new TravelRequestEvents();
